import {FormInputProps} from "_types/form";
import {Form, InputGroup} from 'react-bootstrap';
import {useState} from "react";
import classNames from "classnames";
import MaskedInput from "react-text-mask";
import {Controller, get} from "react-hook-form";

export const CpfInput = ({
    name,
    placeholder,
    refCallback,
    errors,
    control,
    register,
    className,
    ...otherProps
}: FormInputProps) => {
    const fieldErrors = get(errors, name);
    className = classNames(className, 'form-control', {'is-invalid': fieldErrors});

    return (
        <>
            <InputGroup className="mb-0">
                <Controller
                    {...{name, control}}
                    render={
                        ({field: {ref, ...field}}) => {

                            return (
                                <MaskedInput
                                    mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                                    id={name}
                                    {...{...field, ...otherProps, placeholder, className, name}}
                                />
                            )
                        }
                    }/>
            </InputGroup>

            {fieldErrors ? (
                <Form.Control.Feedback type="invalid" className="d-block">
                    {fieldErrors['message'] as any}
                </Form.Control.Feedback>
            ) : null}
        </>
    );
};
